import { render, staticRenderFns } from "./PeriodSalesForm.vue?vue&type=template&id=4753ded2&"
import script from "./PeriodSalesForm.vue?vue&type=script&lang=ts&"
export * from "./PeriodSalesForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports